export const checkFinalPrice = ({ cartItems = [], restaurant, itemPrice = 0 }) => {
  if (!restaurant) return parseFloat(itemPrice) || 0;
  
  const parsedItemPrice = parseFloat(itemPrice) || 0;

  // If no items in cart, simulate final price using only the item being added
  const totalAmount = cartItems.length > 0
    ? cartItems.reduce((acc, item) => acc + (parseFloat(item.totalPrice) || 0), 0)
    : 0;

  let basePrice = totalAmount + parsedItemPrice;
  let final = basePrice;

  restaurant.additionalCharges?.forEach((charge) => {
    if (charge.isActive) {
      const fee = Number(charge.fee) || 0;
      const addedAmount =
        charge.type === "fixed" ? fee : (final * fee) / 100;
      final += addedAmount;
    }
  });

  return final;
};
